import '@angular/compiler';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { App } from './app';
import './styles.css';


bootstrapApplication(App, appConfig).catch((err) => console.error(err));
